<template>
  <div class="appContainer profile-page">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('profile-page.header-update', { split: '/' }) }}</h1>
    </div>
    <v-row class="profile">
      <div class="wrapper-entry">
        <v-col cols="12" md="12" sm="12" lg="12">
          <table class="table-custom" border="1" cellspacing="0" cellpadding>
            <tbody>
              <tr class="tr-response" v-if="isShowBasicInformationField('img')">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="$t('profile-page.avatar-image', { split: '/' })"
                    class="title-left-style"
                  >
                  </label>
                </td>
                <td class="td-right">
                  <div class="img-box">
                    <!-- <img :src="applicant.img" alt="img placeholder" /> -->

                    <UpdateAvatar
                      v-bind:img="img"
                      @getDataImage="getDataImage"
                      ref="updateAvatar"
                    />
                  </div>

                  <button
                    class="btn-update-avatar-image mb-3"
                    @click="changeAvatar"
                    v-html="
                      $t('profile-page.change-avatar', {
                        split: ''
                      })
                    "
                  ></button>

                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                    style="margin-bottom: 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[9].input_example
                        : getInputExample[9].input_example_vn
                    }}
                  </div>
                  <!-- <div>
                <span
                  >{{ $t('profile-page.my-code-title', { split: '/' }) }}:</span
                >
                <span class="entry-code-style">
                  {{ getApplicantEntry }}
                </span>
              </div> -->
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('name')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="$t('profile-page.name', { split: '/' })"
                    class="title-left-style"
                  >
                  </label>
                  <span class="col-require text-right title-right-style"  v-if="isFieldRequired('name')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <input
                      name="name"
                      type="text"
                      class="textarea-input"
                      v-bind:class="{
                        'error-validate': $v.name.$invalid && $v.name.$dirty
                      }"
                      v-model.trim="$v.name.$model"
                      ref="name"
                      autofocus
                    />
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[0].input_example
                          : getInputExample[0].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.name.$invalid && $v.name.$dirty && !$v.name.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.name.$invalid && $v.name.$dirty && !$v.name.maxLength
                      "
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  isShowBasicInformationField('name_kana') &&
                  this.$i18n.locale === LANG_CODE_JAPANESE
                "
              >
                <td class="td-left">
                  <div
                    v-if="
                      isShowBasicInformationField('name_kana') &&
                      this.$i18n.locale === LANG_CODE_JAPANESE
                    "
                  >
                    <label
                      for="name_kana"
                      v-html="
                        $t('profile-page.name_kana', {
                          split: '/'
                        })
                      "
                      class="title-left-style"
                    >
                    </label
                    ><span class="col-require text-right title-right-style" v-if="isFieldRequired('name')">
                      {{
                        $t('profile-page.status.required', {
                          split: '/'
                        })
                      }}
                    </span>
                  </div>
                </td>
                <td class="td-right">
                  <div
                    v-if="
                      isShowBasicInformationField('name_kana') &&
                      this.$i18n.locale === LANG_CODE_JAPANESE
                    "
                  >
                    <div class="input-relative">
                      <input
                        name="name_kana"
                        type="text"
                        class="textarea-input"
                        v-bind:class="{
                          'error-validate':
                            $v.name_kana.$invalid && $v.name_kana.$dirty
                        }"
                        v-model.trim="$v.name_kana.$model"
                        ref="name_kana"
                      />
                      <span
                        class="form-error-tip"
                        v-if="
                          $v.name_kana.$invalid &&
                          $v.name_kana.$dirty &&
                          !$v.name_kana.required
                        "
                        >{{
                          $t('validate.required', {
                            split: '/'
                          })
                        }}</span
                      >
                      <span
                        class="form-error-tip"
                        v-if="
                          $v.name_kana.$invalid &&
                          $v.name_kana.$dirty &&
                          !$v.name_kana.maxLength
                        "
                        >{{
                          $t('validate.out-of-range', {
                            split: '/'
                          })
                        }}</span
                      >
                    </div>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[7].input_example
                          : getInputExample[7].input_example_vn
                      }}
                    </div>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('gender')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.gender', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('gender')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="widget-gender">
                    <button
                      class="btn-custom"
                      :class="gender === MALE ? 'btn-checked' : 'btn-disable'"
                      @click="chooseGender(MALE)"
                    >
                      {{
                        $t('register-page.btn-gender.male', {
                          split: '/'
                        })
                      }}
                    </button>
                    <button
                      class="btn-custom btn-female"
                      :class="gender === FEMALE ? 'btn-checked' : 'btn-disable'"
                      @click="chooseGender(FEMALE)"
                    >
                      {{
                        $t('register-page.btn-gender.female', {
                          split: '/'
                        })
                      }}</button
                    ><button
                      class="btn-custom btn-female"
                      :class="gender === OTHER ? 'btn-checked' : 'btn-disable'"
                      @click="chooseGender(OTHER)"
                    >
                      {{
                        $t('register-page.btn-gender.other', {
                          split: '/'
                        })
                      }}
                    </button>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('birthday')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.birthday', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('birthday')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <div class="date-picker-relative">
                      <v-dialog
                        ref="modal_birthday"
                        v-model="modal_birthday"
                        :return-value.sync="birthday"
                        persistent
                        max-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">
                            mdi-calendar</v-icon
                          >
                        </template>
                        <v-date-picker
                          v-model="birthday"
                          :locale="getLocaleDatePicker()"
                          :max="getMaxDate"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="modal_birthday = false"
                            >{{
                              $t('component.btn-cancle', {
                                split: '/'
                              })
                            }}</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.modal_birthday.save(birthday)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>

                      <v-menu class="v-menu-custom">
                        <template
                          v-slot:activator="{ on, attrs }"
                          class="date-picker-relative"
                        >
                          <v-text-field
                            v-model="birthdayFormattedTextField"
                            :hint="getHint"
                            persistent-hint
                            v-bind="attrs"
                            v-on="on"
                            @blur="handleBirthdayFromTextField"
                            class="input-date-picker"
                          ></v-text-field>
                        </template>
                      </v-menu>
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.birthday.$invalid &&
                        $v.birthday.$dirty &&
                        !$v.birthday.required
                      "
                    >
                      {{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}
                    </span>
                    <span
                      class="form-error-tip"
                      v-if="!$v.birthdayFormattedTextField.birthdayFormatted"
                    >
                      {{
                        $t('validate.date-invalid', {
                          split: '/'
                        })
                      }}
                    </span>
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('mail_address')"
              >
                <td class="td-left">
                  <label
                    for="mail_address"
                    v-html="
                      $t('profile-page.email', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('mail_address')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="mail_address"
                    type="text"
                    class="textarea-input"
                    readonly
                    v-model.trim="mail_address"
                    ref="mail_address"
                  />
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[1].input_example
                        : getInputExample[1].input_example_vn
                    }}
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('phone_number')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.phone', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span
                    class="col-require text-right title-right-style"
                    v-if="
                      m_template.participant_basic_info_type ===
                      this.EVENT_DEFAULT || isFieldRequired('phone')
                    "
                  >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <input
                      name="phone"
                      type="text"
                      class="textarea-input"
                      v-bind:class="{
                        'error-validate':
                          $v.phone_number.$invalid && $v.phone_number.$dirty
                      }"
                      v-model.trim="$v.phone_number.$model"
                      ref="phone_number"
                    />
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[3].input_example
                          : getInputExample[3].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.phone_number.$invalid &&
                        $v.phone_number.$dirty &&
                        !$v.phone_number.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >

                    <span
                      class="form-error-tip"
                      v-if="
                        $v.phone_number.$invalid &&
                        $v.phone_number.$dirty &&
                        !$v.phone_number.maxLength &&
                        $v.phone_number.helpers
                      "
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.phone_number.$invalid &&
                        $v.phone_number.$dirty &&
                        !$v.phone_number.helpers
                      "
                      >{{
                        $t('validate.phone-format', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('address')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.address1', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('area_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="area_id"
                      v-model="area_id"
                      class="select-option-style"
                      :disabled="isFieldReadonly('area_id')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_area"
                        v-bind:value="item.id"
                      >
                        {{ item.area_name }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[4].input_example
                          : getInputExample[4].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.area_id.$invalid &&
                        $v.area_id.$dirty &&
                        !$v.area_id.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('address')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.address2', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('address')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <input
                      name="address"
                      type="text"
                      class="textarea-input"
                      v-bind:class="{
                        'error-validate':
                          $v.address.$invalid && $v.address.$dirty
                      }"
                      v-model.trim="$v.address.$model"
                      ref="address"
                    />
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[5].input_example
                          : getInputExample[5].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.address.$invalid &&
                        $v.address.$dirty &&
                        !$v.address.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.address.$invalid &&
                        $v.address.$dirty &&
                        !$v.address.maxLength
                      "
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('hometown_id')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.place-of-birth', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('hometown_id')" >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="hometown_id"
                      v-model="hometown_id"
                      class="select-option-style"
                      :disabled="isFieldReadonly('hometown_id')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_hometown"
                        v-bind:value="item.id"
                      >
                        {{ item.hometown_name }}
                      </option>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[6].input_example
                          : getInputExample[6].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.hometown_id.$invalid &&
                        $v.hometown_id.$dirty &&
                        !$v.hometown_id.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('facebook')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="$t('profile-page.facebook')"
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('facebook')" >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <input
                      name="facebook"
                      type="text"
                      class="textarea-input"
                      v-bind:class="{
                        'error-validate':
                          $v.facebook.$invalid && $v.facebook.$dirty
                      }"
                      v-model.trim="$v.facebook.$model"
                      ref="facebook"
                    />
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[7].input_example
                          : getInputExample[7].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.facebook.$invalid &&
                        $v.facebook.$dirty &&
                        !$v.facebook.maxLength
                      "
                      >{{
                        $t('validate.out-of-range', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowBasicInformationField('time_zone')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('profile-page.timezone', {
                        split: '/'
                      })
                    "
                    class="title-left-style"
                  ></label>
                  <span class="col-require text-right title-right-style" v-if="isFieldRequired('time_zone')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div class="input-relative">
                    <select
                      name="time_zone"
                      v-model="time_zone"
                      class="select-option-style"
                      :disabled="isFieldReadonly('time_zone')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <template v-for="item in c_time_zone">
                        <option
                          v-bind:key="item.id"
                          v-if="checkTimeZone(item.id)"
                          v-bind:value="item.id"
                        >
                          {{ item.name_convert }}
                        </option>
                      </template>
                    </select>
                    <div
                      class="input-example-style"
                      v-if="getInputExample.length !== 0"
                    >
                      {{
                        this.$i18n.locale === LANG_CODE_JAPANESE
                          ? getInputExample[8].input_example
                          : getInputExample[8].input_example_vn
                      }}
                    </div>
                    <span
                      class="form-error-tip"
                      v-if="
                        $v.time_zone.$invalid &&
                        $v.time_zone.$dirty &&
                        !$v.time_zone.required
                      "
                      >{{
                        $t('validate.required', {
                          split: '/'
                        })
                      }}</span
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </div>
    </v-row>

    <v-row>
      <v-col class="text-center">
        <v-btn
          depressed
          class="btn-cancer mt-2 mb-2"
          outlined
          color="#e8320e"
          @click="closeUpdate"
          >{{ $t('component.button-cancer', { split: '/' }) }}</v-btn
        >

        <v-btn
          class="btn-update ml-2"
          depressed
          color="#E8320D"
          @click="handleShowDetail"
          >{{ $t('component.button-update', { split: '/' }) }}</v-btn
        >

        <v-dialog v-model="dialog" max-width="520">
          <v-card class="dialog-container">
            <v-icon
              color="#E8320D"
              class="close-icon"
              @click="handleCloseDialog"
              >{{ closeIcon }}</v-icon
            >
            <div class="dialog">
              <h4 v-html="$t('header.confirm-update', { split: '/' })"></h4>
              <v-card-actions>
                <v-btn
                  class="btn-logout"
                  depressed
                  color="#e8320e"
                  @click="updateEvent"
                  :loading="btnLoading"
                >
                  <!-- <router-link tag="span" :to="pathDefault"> -->
                  {{ $t('header.btn-confirm', { split: '/' }) }}
                  <!-- </router-link> -->
                </v-btn>

                <v-btn
                  @click="handleCloseDialog"
                  outlined
                  color="#e8320e"
                  class="btn-cancerDialog"
                >
                  {{ $t('header.btn-cancer', { split: '/' }) }}
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import {
  MALE,
  FEMALE,
  OTHER,
  LANG_JAPANESE,
  LANG_VIETNAMESE,
  LANG_CODE_VIETNAMESE,
  EVENT_DEFAULT,
  EVENT_SECOND_CAREER,
  LANG_CODE_JAPANESE
} from '@/common/constants';

import {
  required,
  // email,
  // sameAs,
  // alphaNum,
  // minLength,
  maxLength,
  helpers
} from 'vuelidate/lib/validators';
import UpdateAvatar from '@/components/UpdateAvatar.vue';

import { mdiClose } from '@mdi/js';

import { dateFormated } from '@/validators/date';
export default {
  components: {
    UpdateAvatar: UpdateAvatar
  },

  data: (vm) => {
    return {
      closeIcon: mdiClose,
      dialog: false,
      img: '',
      name: '',
      name_kana: '',
      gender: 0,
      birthday: '',
      phone_number: '',
      address: '',
      area_id: '',
      hometown_id: '',
      facebook: '',
      time_zone: '',
      mail_address: '',
      modal_birthday: false,
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      lang: '',
      locale: 'vi',
      btnLoading: false,
      EVENT_DEFAULT,
      EVENT_SECOND_CAREER,

      birthdayFormattedTextField: vm.formatDate(
        new Date().toISOString().substr(0, 10)
      )
    };
  },

  validations() {
    const createDynamicValidations = () => {
      let baseValidations = {};

      if (this.m_template.participant_basic_info_type === this.EVENT_DEFAULT) {
        baseValidations = {
          name: {
            required,
            maxLength: maxLength(100)
          },
          phone_number: {
            required,
            maxLength: maxLength(20),
            helpers: helpers.regex('', /^[ 0-9-+()]+$/)
          },
          address: {
            required,
            maxLength: maxLength(100)
          },
          area_id: {
            required
          },
          hometown_id: {
            required
          },
          facebook: {
            maxLength: maxLength(100)
          },
          time_zone: {
            required
          },
          birthday: {
            required
          },
          birthdayFormattedTextField: {
            birthdayFormatted: dateFormated('birthdayFormattedTextField')
          }
        };
      } else if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        baseValidations = {
          name: {
            required,
            maxLength: maxLength(100)
          },
          name_kana: {
            required,
            maxLength: maxLength(100)
          },
          phone_number: {
            maxLength: maxLength(20),
            helpers: helpers.regex('', /^[ 0-9-+()]+$/)
          },
          address: {
            required,
            maxLength: maxLength(100)
          },
          area_id: {
            required
          },
          hometown_id: {
            required
          },
          birthday: {
            required
          },
          birthdayFormattedTextField: {
            birthdayFormatted: dateFormated('birthdayFormattedTextField')
          }
        };
      } else {
        baseValidations = {
          name: {
            required,
            maxLength: maxLength(100)
          },
          phone_number: {
            maxLength: maxLength(20),
            helpers: helpers.regex('', /^[ 0-9-+()]+$/)
          },
          address: {
            required,
            maxLength: maxLength(100)
          },
          area_id: {
            required
          },
          hometown_id: {
            required
          },
          birthday: {
            required
          },
          birthdayFormattedTextField: {
            birthdayFormatted: dateFormated('birthdayFormattedTextField')
          }
        };
      }

      // Apply form modifications only if they exist and m_event is available
      if (this.m_event && this.m_event.modify_fields) {
        Object.keys(baseValidations).forEach((fieldName) => {
          const modification = this.m_event.modify_fields.find(
            (mod) => mod.name === fieldName
          );
          if (modification && modification.hasOwnProperty('required')) {
            if (modification.required === false) {
              delete baseValidations[fieldName].required;
            } else if (
              modification.required === true &&
              !baseValidations[fieldName].required
            ) {
              // Add required validation if not already present
              baseValidations[fieldName].required = required;
            }
          }
          // Handle type property modifications - convert numeric fields to text
          if (modification &&
              modification.type === 'text' &&
              baseValidations[fieldName].hasOwnProperty('numeric')) {
            // Remove numeric and between validators for text type fields
            delete baseValidations[fieldName].numeric;
            delete baseValidations[fieldName].between;
          }
        });
      }

      return baseValidations;
    };

    return createDynamicValidations();
  },

  watch: {
    phone_number: function (val) {
      return val;
    },
    applicant: function (val) {
      return [
        (this.img = val.img),
        (this.name = val.name),
        (this.name_kana = val.name_kana),
        (this.gender = val.gender),
        (this.birthday = val.birthday),
        (this.phone_number = val.phone_number),
        (this.address = val.address),
        (this.area_id = val.area_id),
        (this.hometown_id = val.hometown_id),
        (this.facebook = val.facebook),
        (this.time_zone = val.time_zone),
        (this.mail_address = val.mail_address)
      ];
    },
    updateBasicInformationStatus: function (val, oldVal) {
      if (val !== oldVal && val === true) {
        this.$emit('updateEvent');
        this.btnLoading = false;
        this.resetStatusUpdateBasicInformation();
      }
    },
    birthday: function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = val;
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('-');
          string = year + '/' + month + '/' + day;
        } else {
          const [year, month, day] = datetime.split('-');
          string = day + '/' + month + '/' + year;
        }
        this.birthdayFormattedTextField = string;
      }
    },
    '$i18n.locale': function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = this.birthday;
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('-');
          string = year + '/' + month + '/' + day;
        } else {
          const [year, month, day] = datetime.split('-');
          string = day + '/' + month + '/' + year;
        }
        this.birthdayFormattedTextField = string;
      }

      //   if (this.$i18n.locale === LANG_CODE_JAPANESE) {
      //     return (this.time_zone = TIME_ZONE_JP);
      //   } else {
      //     return (this.time_zone = TIME_ZONE_VN);
      //   }
    }
  },

  computed: {
    ...mapGetters({
      m_template: 'getMTemplate',
      m_event: 'getEventData',
      applicant: 'getBasicInfomation',
      current_lang: 'getCurrentLanguage',
      langInStore: 'getLang'
    }),

    birthdayFormatted() {
      return this.formatDate(this.birthday);
    },

    ...mapState({
      updateBasicInformationStatus: 'updateBasicInformationStatus'
    }),

    getMaxDate() {
      return new Date().toJSON();
    },

    getInputExample() {
      return this.m_input_example.filter((el) => el.screen_id === 1);
    }
  },

  beforeDestroy() {
    const {
      img,
      name,
      name_kana,
      gender,
      birthday,
      phone_number,
      address,
      area_id,
      hometown_id,
      facebook,
      time_zone,
      mail_address
    } = this.applicant;

    return [
      (this.img = img),
      (this.name = name),
      (this.name_kana = name_kana),
      (this.gender = gender),
      (this.birthday = birthday),
      (this.phone_number = phone_number),
      (this.address = address),
      (this.area_id = area_id),
      (this.hometown_id = hometown_id),
      (this.facebook = facebook),
      (this.time_zone = time_zone),
      (this.mail_address = mail_address)
    ];
  },

  mounted() {
    const {
      img,
      name,
      name_kana,
      gender,
      birthday,
      phone_number,
      address,
      area_id,
      hometown_id,
      facebook,
      time_zone,
      mail_address
    } = this.applicant;

    // Load applicant data
    this.img = img;
    this.name = name;
    this.name_kana = name_kana;
    this.gender = gender;
    this.birthday = birthday;
    this.phone_number = phone_number;
    this.address = address;
    this.area_id = area_id;
    this.hometown_id = hometown_id;
    this.facebook = facebook;
    this.time_zone = time_zone;
    this.mail_address = mail_address;

    // Load default values from m_event.modify_fields if no existing data
    if (this.m_event && this.m_event.modify_fields) {
      this.m_event.modify_fields.forEach((field) => {
        if (field.default_value && this.hasOwnProperty(field.name) && !this[field.name]) {
          this[field.name] = field.default_value;
        }
      });
    }
  },

  created() {
    this.MALE = MALE;
    this.FEMALE = FEMALE;
    this.OTHER = OTHER;
  },

  methods: {
    handleShowDetail() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.dialog = true;
      }
    },
    handleCloseDialog() {
      this.dialog = false;
    },
    getDataImage: function (data) {
      this.img = data;
    },

    changeAvatar() {
      this.$refs.updateAvatar.$refs.file.click();
    },

    chooseGender: function (key) {
      this.gender = key;
    },

    formatString(str) {
      // loai bo khoang trang khoi chuoi
      if (str) {
        str = str.replace(/\s+/g, ' ').trim();
      }
      return str;
    },
    formatString2(str) {
      // loai bo hoan toan cac khoang trang
      if (str) {
        str = str.replace(/\s+/g, '').trim();
      }
      return str;
    },

    updateEvent() {
      this.$v.$touch();
      this.btnLoading = true;
      if (!this.$v.$error) {
        const {
          img,
          name,
          name_kana,
          gender,
          birthday,
          phone_number,
          address,
          area_id,
          hometown_id,
          facebook,
          time_zone,
          mail_address
        } = this;

        const nameValid = this.formatString(name);
        const name_kanaValid = this.formatString(name_kana);
        const addressValid = this.formatString(address);
        const mail_addressValid = this.formatString(mail_address);
        const fbValid =
          facebook === null ? facebook : this.formatString2(facebook);

        const data = {
          name: nameValid,
          name_kana: name_kanaValid,
          gender,
          birthday,
          img,
          phone_number,
          address: addressValid,
          area_id,
          hometown_id,
          facebook: fbValid,
          time_zone,
          mail_addrss: mail_addressValid
        };

        data.lang =
          this.langInStore === LANG_CODE_VIETNAMESE
            ? LANG_VIETNAMESE
            : LANG_JAPANESE;
        this.$store.dispatch('updateBasicInformation', { data });
      } else {
        this.btnLoading = false;
      }
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      if (this.current_lang === LANG_CODE_VIETNAMESE)
        return `${day}/${month}/${year}`;
      else return `${year}/${month}/${day}`;
    },

    closeUpdate() {
      this.$emit('updateEvent');
    },

    ...mapMutations({
      resetStatusUpdateBasicInformation: 'UPDATE_INFORMATION_ERROR'
    }),

    handleBirthdayFromTextField() {
      let string = '';
      const datetime = this.birthdayFormattedTextField;

      if (this.checkDateFormate(datetime)) {
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        } else {
          const [day, month, year] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        }
        this.birthday = string;
      }
    },

    checkDateFormate(dateString) {
      const regex = this.$i18n.locale === LANG_CODE_JAPANESE
        ? /^\d{4}\/\d{1,2}\/\d{1,2}$/
        : /^\d{1,2}\/\d{1,2}\/\d{4}$/;
      return regex.test(dateString);
    },

    checkTimeZone(id) {
      const listId = this.m_template.timezone
        .replace(/[ \[\]]/g, '')
        .split(',');
      return listId.indexOf(id + '') > -1;
    },

    // ====================
    // FIELD CONFIGURATION METHODS
    // ====================
    isFieldRequired(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('required')) {
        return modification.required;
      }
      const defaultRequired = [
        'name', 'name_en', 'gender', 'birthday', 'mail_address',
        're_mail_address', 'address', 'hometown_id', 'area_id', 'time_zone'
      ];
      if (this.m_template.participant_basic_info_type === this.EVENT_DEFAULT) {
        defaultRequired.push('phone_number');
      }
      return defaultRequired.includes(fieldName);
    },

    isFieldReadonly(fieldName, defaultValue = false) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      return modification ? modification.readonly : defaultValue;
    },

    getFieldDefaultValue(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      return modification && modification.default_value
        ? modification.default_value
        : '';
    },

    getFieldValidationRules(fieldName) {
      const rules = [];
      if (this.isFieldRequired(fieldName)) {
        rules.push({type: 'required', pathTextLang: 'validate.required'});
      }

      const fieldRules = {
        name: [{type: 'maxLength', pathTextLang: 'validate.out-of-range'}],
        name_kana: [{type: 'maxLength', pathTextLang: 'validate.out-of-range'}],
        mail_address: [
          {type: 'email', pathTextLang: 'validate.email-invalid'},
          {type: 'mailExisted', pathTextLang: 'validate.email-duplicated'},
          {type: 'maxLength', pathTextLang: 'validate.out-of-range'}
        ],
        re_mail_address: [
          {type: 'email', pathTextLang: 'validate.email-invalid'},
          {type: 'sameAsEmail', pathTextLang: 'validate.email-not-match'}
        ],
        phone_number: [
          {type: 'maxLength', pathTextLang: 'validate.out-of-range'},
          {type: 'helpers', pathTextLang: 'validate.phone-format'}
        ],
        address: [{type: 'maxLength', pathTextLang: 'validate.out-of-range'}]
      };

      return rules.concat(fieldRules[fieldName] || []);
    },

    preventChangeIfReadonly(event, fieldName) {
      if (this.isFieldReadonly(fieldName)) {
        event.preventDefault();
      }
    },

    // Add missing method for compatibility
    isShowBasicInformationField(fieldName) {
      // Implementation based on template configuration
      return true; // Default implementation
    }
  }
};
</script>

<style lang="scss">
@import './profile.scss';
@import '@/style/common.scss';

.input-example-style {
  display: flex;
  margin-top: 0.5rem;
  white-space: pre-wrap;
}

.edit-input-style {
  width: 100%;
}

.btn-update-avatar-image {
  background-color: #e9330e;
  padding: 5px 12px;
  color: #fff;
  border-radius: 5px;
  margin-top: 11px;
  &:focus {
    outline: none;
  }
}

.entry-code-style {
  color: $primary_red;
  font-weight: bold;
  font-size: 24px;
}

.title-left-style {
  font-weight: 600;
  color: #545454;
}

.title-right-style {
  font-weight: 600;
  color: #e80018;
}

.textarea-input {
  background-color: #ffe7e5;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 8px 15px;
  width: 100%;
}

.select-option-style {
  background-color: #fff;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 8px 15px;
  width: 100%;
}

.select-option-style:focus {
  outline: none;
}

.widget-gender {
  width: 100%;
  display: flex;

  .btn-custom {
    background-color: #e9330e;
    height: 40px;
    // min-width: 300px;
    width: calc((100% - 12px) / 3);

    color: #fff;
    border-radius: 5px;
    &:focus {
      outline: none;
    }
  }
  .btn-female {
    margin-left: 12px;
  }

  .btn-checked {
    background-color: #e9330e;
  }
  .btn-disable {
    background-color: #ececec;
  }
}
</style>
